import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import { usePageLayout } from "@/app/routes/pageLayout";
import { LAYOUT_AVATAR_Z_INDEX, PAGE_PADDING } from "@/constants";
import { AdminSidebar } from "@/features/admin/ui/AdminSidebar";
import { useAuth } from "@/shared/auth/useAuth";
import { useCognitoSignOut } from "@/shared/auth/useCognitoSignOut";
import { PageContainer } from "@/shared/ui/layout/PageContainer";
import { UserAccountMenu } from "@/shared/ui/layout/UserAccountMenu";

export function AdminLayout() {
  const { isAuthenticated } = useAuth();
  const signOut = useCognitoSignOut();
  const { maxWidthPx } = usePageLayout();

  return (
    <Box sx={{ display: "flex", minHeight: "100%", height: "100%" }}>
      <AdminSidebar />
      <Box
        component="main"
        sx={{ flex: 1, minWidth: 0, minHeight: 0, display: "flex", flexDirection: "column" }}
      >
        <Box sx={{ flex: 1, minHeight: 0, overflow: "auto" }}>
          <Box
            sx={{
              width: "100%",
              maxWidth: maxWidthPx,
              mx: "auto",
              minHeight: "100%",
              display: "flex",
              alignItems: "stretch",
              position: "relative",
            }}
          >
            {isAuthenticated ? (
              <Box
                sx={{
                  position: "absolute",
                  top: PAGE_PADDING.DEFAULT.Y_PX,
                  right: PAGE_PADDING.DEFAULT.RIGHT_PX,
                  zIndex: LAYOUT_AVATAR_Z_INDEX,
                }}
              >
                <UserAccountMenu onLogout={signOut} />
              </Box>
            ) : null}
            <PageContainer>
              <Outlet />
            </PageContainer>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
